<div style="position:relative">
  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>{{ label }}</mat-label>
    <input matInput [value]="displayValue" [disabled]="isDisabled" (keydown)="onKeydown($event)"
      [placeholder]="use24Hour ? 'MM/DD/YYYY HH:MM' : 'MM/DD/YYYY HH:MM AM/PM'" (input)="onManualInput($event)"
      (blur)="onManualBlur($event)" />
    <button mat-icon-button matSuffix type="button" (click)="togglePanel($event)" [disabled]="isDisabled">
      <mat-icon>calendar_today</mat-icon>
    </button>
  </mat-form-field>
  
  <!--calendar on left, spinners at right — matches client's Image 3 -->
  <div class="dt-panel mat-elevation-z8" *ngIf="panelOpen" [class.panel-align-right]="panelPosition === 'right'" (click)="$event.stopPropagation()">
    <div class="dt-panel-inner">
      <!-- Calendar -->
      <div class="dt-calendar-col">
        <mat-calendar [selected]="internalDate" [startAt]="internalDate" (selectedChange)="onCalendarDateSelected($event)">
        </mat-calendar>
      </div>

      <!-- Divider -->
      <div class="dt-divider"></div>

      <!-- RIGHT: Time spinners -->
      <div class="dt-time-col">
        <div class="time-spinners-row">
          <!-- Hours -->
          <div class="spinner">
            <button mat-icon-button type="button" (click)="incrementHour()">
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <span class="time-val">{{ paddedHour }}</span>
            <button mat-icon-button type="button" (click)="decrementHour()">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>
    
          <span class="colon">:</span>
    
          <!-- Minutes -->
          <div class="spinner">
            <button mat-icon-button type="button" (click)="incrementMinute()">
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <span class="time-val">{{ paddedMinute }}</span>
            <button mat-icon-button type="button" (click)="decrementMinute()">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>

          <ng-container *ngIf="!use24Hour">
            <div class="spinner">
              <button mat-icon-button type="button" (click)="toggleMeridian()">
                  <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
              <span class="time-val">{{ meridian }}</span>
              <button mat-icon-button type="button" (click)="toggleMeridian()">
                  <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
            </div>
        </ng-container>
    
          <!-- Confirm ✓ -->
          <!--<button mat-icon-button mat-primary type="button"
                  class="confirm-btn" (click)="confirmSelection()">
            <mat-icon>check</mat-icon>
          </button>-->
        </div>
      </div>
    </div>
  </div>
</div>
